const crypto = require("crypto-js");

const CIPHER_KEY = "SrQYNyJ47CwSa2RAtBA7Hky7wlnAY1T1";
const CIPHER_IV = "CcR2G6IMj4bgBVQg";

export const encrypt = (text) => {
  if (!text) {
    return null;
  }
  const cipher = crypto.AES.encrypt(text, crypto.enc.Utf8.parse(CIPHER_KEY), {
    iv: crypto.enc.Utf8.parse(CIPHER_IV),
    mode: crypto.mode.CBC,
    format: crypto.format.Hex,
    padding: crypto.pad.Pkcs7
  });
  return cipher.toString();
};

export const decrypt = (text) => {
  if (!text) {
    return null;
  }
  const cipher = crypto.AES.decrypt(text, crypto.enc.Utf8.parse(CIPHER_KEY), {
    iv: crypto.enc.Utf8.parse(CIPHER_IV),
    mode: crypto.mode.CBC,
    format: crypto.format.Hex,
    padding: crypto.pad.Pkcs7
  });
  return cipher.toString(crypto.enc.Utf8);
};
